export default __webpack_public_path__ + "static/media/offer.83494162.png";